






























import {Component, Vue} from 'vue-property-decorator';
import FormTemplate from '../FormTemplate.vue';
import AmetrasTextFieldTemplate from '../../../fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import {FormularInstance} from '../form.interface';

const defaultFormular: FormularCofig = Object.freeze({
  templateUrl: '/dynamicdocuments/v1/form/documents/template?id=21',
  createMode: false,
  context: '{ "timeStamp": "2019-05-15", "job": {"companyNo": 123} }'
});

interface FormularCofig {
  templateUrl: string;
  createMode: boolean;
  context: string;
}

@Component({
  components: {AmetrasTextAreaFieldTemplate, AmetrasCheckBoxTemplate, AmetrasTextFieldTemplate, FormTemplate}
})
export default class FormTester extends Vue {

  formularConfig: FormularCofig = {...defaultFormular};
  loadCounter: number = 0;
  formularInstance: FormularInstance | null = null;

  afterFormularInitialized(formularInstance: FormularInstance) {
    this.formularInstance = formularInstance;
  }

}
